<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">
      Rechercher un rendez-vous libre
    </div>
    <div class="modal-body">

      <div class="form-part" *ngIf="formGroup">

        <frg-form-input
          id="resource"
          type="ngSelect"
          [formGroup]="formGroup"
          [control]="formGroup.get('resource')"
          [selectValue]="resourcesLabel"
          [isClearableSelect]="false"
          label="Ressource"
        ></frg-form-input>

        <frg-form-input label="Prochains RDV libres pour tout le cabinet" id="allOffice" type="checkbox"
          [formGroup]="formGroup" [control]="formGroup.get('allOffice')"
          [isCheckLabelAlign]="true" [isGreenLabel]="true">
        </frg-form-input>

        <frg-form-input
          [id]="date"
          [formGroup]="formGroup"
          [control]="formGroup.get('date')"
          type="date"
        ></frg-form-input>
        <div class="select-length" [formGroup]="formGroup">
          <div class="select-length-type">
            <div class="radio">
              <input id="selectLength" type="radio" [value]="'length'" formControlName="selectLength" />
              <label>Durée en minutes</label>
            </div>
            <div class="select-value" [ngClass]="{ 'disabled': formGroup.get('selectLength').value !== 'length' }">
              <frg-form-input
                id="length"
                [formGroup]="formGroup"
                [control]="formGroup.get('length')"
                type="ngSelect"
                [selectValue]="lengths"
                [isClearableSelect]="false"
              ></frg-form-input>
            </div>
          </div>
          <div class="select-length-type">
            <div class="radio">
              <input id="selectType" type="radio" [value]="'type'" formControlName="selectLength" />
              <label>Type</label>
            </div>
            <div class="select-value" [ngClass]="{ 'disabled': formGroup.get('selectLength').value !== 'type' }">
              <frg-form-input
                id="type"
                [formGroup]="formGroup"
                [control]="formGroup.get('type')"
                type="ngSelect"
                [selectValue]="eventTypesLabel"
                [isClearableSelect]="false"
              ></frg-form-input>
            </div>
          </div>
        </div>
        <div class="button-wrapper">
          <frg-button (activated)="closeModal(null)" backgroundColor="var(--darkest-primary)">Annuler</frg-button>
          <frg-button (activated)="doSearchEvents()">Rechercher</frg-button>
          <div class="error-msg" *ngIf="errorMsg !== ''">{{ errorMsg }}</div>
        </div>
      </div>

      <div class="result-list" *ngIf="searchResult && searchResult.objects.length > 0">
        <frg-table
          [keysBody]="searchResult"
          [keysColumn]="periodesColumnTable"
          [isRowsClickable]="true"
          (onClickRow)="selectSlot($event)"
        ></frg-table>
      </div>
      <div class="no-result" *ngIf="(!searchResult || searchResult.objects.length === 0) && noResult">
        Aucun créneau disponible.
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>